import { store } from '@/store';
import _ from 'lodash';
import dateTransform from '@/utils/dateTransform';

const insurance = {
    /**
     * 取得 API-13 已驗證之險種選單資訊，並重設原本已選取項目
     * @returns {Promise}
     */
    setValidInsAndCovers() {        
        // [2024-04-01]每次都要重取資料
        
        return axios.post(apiUrl.GetValidInsAndCovers, store.getters['estimate/getData'])
            .then(res => {
                if (res.data.Code === 200) return store.dispatch('clearValidData').then(() => res.data.Data);

                return Promise.reject('Status code not returned as 200'); // 只有 201 - 299 才會到
            }).then(data => {
                _.forEach(data, o => {
                    if (store.state['ins' + o.InsType]) {
                        store.commit('ins' + o.InsType + '/setValidData', o);
                    }
                });

                // 檢查如果已選取的項目沒有回傳選項，要取消選取
                const insurances = store.state.policy.allInsurances;

                for (let i = 0; i < insurances.length; i++) {
                    let item = store.state['ins' + insurances[i]];
                    if (item.selected) {
                        // 檢查是否在回傳的項目內
                        if (!_.some(data, {InsType: insurances[i]})) {
                            store.commit('ins' + insurances[i] + '/select', false);
                        }
                    }
                }

            });
    },
    /**
     * 下載並儲存各險種顯示名稱
     * @returns {Promise}
     */
    setInsuresName: () => {

        // 如果已下載過就不重覆下載
        if (store.state.insCategory == 'Car' && store.state.policy.insuresNameLoadedCar) {
            return Promise.resolve();
        } else if (store.state.insCategory == 'Motorcycle' && store.state.policy.insuresNameLoadedMotor) {
            return Promise.resolve();
        }

        return axios.post(apiUrl.InsuresName, {
            'InsCategory': store.state.insCategory,
        }).then(res => {
            if (res.data.Code !== 200) return null;
            let errors = [];

            res.data.Data.forEach(o => {

                if (store.state['ins' + o.InsType]) {

                    store.commit('ins' + o.InsType + '/setName', o.InsName);

                    if (!o.InsName) errors.push(o.InsType);
                }
            });

            if (errors.length) {
                store.commit('setDialog', {
                    active: true,
                    title: '險種名稱載入錯誤',
                    text: '以下險種名稱未載入：' + errors.join(',')
                });

                return null;
            }

            if (store.state.insCategory == 'Car') {
                store.commit('policy/setInsuresNameLoadedCar', true);
                store.commit('policy/setInsuresNameLoadedMotor', false);
            } else {
                store.commit('policy/setInsuresNameLoadedMotor', true);
                store.commit('policy/setInsuresNameLoadedCar', false);
            }
        });
    },
    /**
     * 儲存 API 回傳之保單 insures 內容進 store
     * 計算保單金額
     * (api-8, api-2, api-39, api-17)
     * @param insurances
     */
    setPolicyInsuresFromApi(insurances) {

        let price = 0;
        _.forEach(insurances, (value, key) => {
            price += value.IndirectPrem;
            store.commit('ins' + key + '/setUploadForm', value);
            store.commit('ins' + key + '/select', true);
        });

        store.commit('policy/setPrice', price);
    },
    /**
     * 取出 storage 的保險資料，組合成 api-17,api-39 需要的保險資料格式
     * @returns {Object}
     */
    setUploadInsurances() {
        const insurances = store.state.policy.allInsurances;

        let obj = new Object(null);

        for (let i = 0; i < insurances.length; i++) {
            let item = store.state['ins' + insurances[i]];
            if (item.selected) {
                obj[insurances[i]] = item.uploadForm;
            }
        }

        return obj;
    },
    /**
     * 取出已選取的險種
     * @returns {Object}
     */
    getSelectedInsTypes(){
        const insurances = store.state.policy.allInsurances;

        let arr = [];

        for (let i = 0; i < insurances.length; i++) {
            let item = store.state['ins' + insurances[i]];
            if (item.selected) {
                arr.push(insurances[i]);
            }
        }

        return arr;
    },

    /**
     * 取得保額/自負額物件
     * 如果DB更改自負額，這裡也要調整
     * @param {Object} options: 選項
     * @param {Number} value: 值
     * @param {String} insTypeOrUnit: 險種或單位 - default 貨幣顯示單位
     * @return {Object}
     */
    getCoverObj(options, value, insTypeOrUnit = ''){
        let found = null;

        if(!!options && !!value){
            found = _.find(options, {value: value.toString()});
            // 沒在有效選項內找到符合的value 就帶入選項的第一個值
            found = !!found ? found : options[0];
        }

        if(!found && !!value){
            let valtxt = '';
            let alias = {
                '11': 'burglary',
                '01': 'damage',
                '05': 'damage'
            };
            let insTypeOptions = {
                'burglary':[
                    { text: '10%', value: '10' },
                    { text: '無自負額', value: '0' },
                    { text: '20%', value: '20' },
                ],
                'damage':[
                    { text: '無自負額', value: '0' },
                    { text: '3千/5千/7千', value: '1' },
                    { text: '5千/8千/1萬', value: '3' },
                    { text: '10000', value: '10000' },
                ],
            };

            if(!!alias[insTypeOrUnit]){
                found = _.find(insTypeOptions[alias[insTypeOrUnit]], {value: value.toString()});
            }
            else{
                if(value >= 10000){
                    valtxt = (value/10000.0) + '萬';
                }
                else if(value == '999' && insTypeOrUnit == '公里'){
                    // 配合238調整
                    valtxt = '不限里程';
                }
                else{
                    valtxt = value + (!insTypeOrUnit ? '元' : insTypeOrUnit);
                }
    
                found = {text: valtxt, value: value};
            }
        }

        return found;
    },

    /**
     * 取得保額/自負額文字
     * @param {Object} options: 選項
     * @param {Number} value: 值
     * @param {String} insTypeOrUnit: 險種或單位 - default 貨幣顯示單位
     * @return {String}
     */
    getCoverText(options, value, insTypeOrUnit = ''){
        let found = this.getCoverObj(options, value, insTypeOrUnit);

        return found?.text || '';
    },

    /**
     * 轉換物件成有 text, value key的物件
     * @param {Object} obj 
     * @returns {Object}
     */
    getDefaultObj(obj){
        return {
            // 如果不在意null 跟 undefined的差別，後面的 || null 可以拿掉
            text: obj?.text || null,
            value: obj?.value || null,
        };
    },

    /** PAS 資料（只有 56 或 166 或 147 需要）
     * @param {Object} beneficiaries 附加駕駛人傷害險被保險人名冊
     * @returns {Boolean} 是否過驗證
     */
    validateAndSetPas(beneficiaries){
        let rtnMsg = '';

        if(!beneficiaries || beneficiaries.length == 0) {
            rtnMsg = '';
        }
        else if (store.state.ins56.selected) {
            if (beneficiaries.some(item => !item.id)) {
                rtnMsg = '附加駕駛人傷害險被保險人名冊的ID不可空白';
                // 缺少id
            } else {
                // 檢查有無重複的ID
                const hasDuplicates = beneficiaries.some((item, index) =>
                    beneficiaries.filter((value, idx) =>
                        value.id.toUpperCase() === item.id.toUpperCase() && idx !== index
                    ).length > 0
                );
    
                if (hasDuplicates) {
                    rtnMsg = '附加駕駛人傷害險被保險人名冊的ID不可重複';
                } else {
                    this.setPas('ins56', beneficiaries);
                }
            }

        } else if (store.state.ins166.selected) {
            // 檢查駕駛人姓名
            if(beneficiaries[0].name != store.state.estimate.AssuredName){
                rtnMsg = '附加駕駛人傷害險被保險人名冊的姓名不同';
            }else{
                this.setPas('ins166', beneficiaries);
            }
        } else if (store.state.ins147.selected) {
            // 檢查駕駛人姓名
            if(beneficiaries[0].name != store.state.estimate.AssuredName){
                rtnMsg = '附加駕駛人傷害險被保險人名冊的姓名不同';
            }else{
                this.setProvs(beneficiaries);
            }
        }

        if(!!rtnMsg){
            store.commit('setAllowLeavePage', true);
            store.commit('setDialog', {
                title: '輸入資料有誤',
                text: rtnMsg,
                active: true
            });
            store.commit('closeLoading');
            return false;
        }

        return rtnMsg === '';
    },
    /*** 附加駕駛人傷害險被保險人名冊 寫入 store
     * @param {String} value ins56 or ins166
     * @param {Object} beneficiaries 附加駕駛人傷害險被保險人名冊
     */
    setPas(value, beneficiaries) {
        const sample = Object.values(store.state[value].uploadForm.Pas)[0];

        let pas = {};
        _.forEach(beneficiaries, o => {
            pas[o.id] = {...sample};
            pas[o.id].InsurantId = o.id.toUpperCase();
            pas[o.id].InsurantName = o.name;
            pas[o.id].InsurantBirthday = o.birthday;
            pas[o.id].BeneficiaryRelation = o.beneficiaryRelation;
            if (o.beneficiaryRelation === '6') {
                pas[o.id].BeneficiaryName = '法定繼承人';
                pas[o.id].BeneficiaryTel = null;
                pas[o.id].BeneficiaryZip = null;
                pas[o.id].BeneficiaryAddress = null;
            } else {
                pas[o.id].BeneficiaryName = o.beneficiaryName;
                pas[o.id].BeneficiaryTel = o.beneficiaryTel;
                pas[o.id].BeneficiaryZip = o.beneficiaryZip;
                pas[o.id].BeneficiaryAddress = o.beneficiaryAddress;
            }
        });

        if (store.state.ins56.selected) {
            store.commit('ins56/setPas', pas);
        } else if (store.state.ins166.selected) {
            store.commit('ins166/setPas', pas);
        }
    },
    /*** 附加駕駛人傷害險被保險人名冊 147 寫入 store policy Provs
     * @param {Object} beneficiaries 附加駕駛人傷害險被保險人名冊
     */
    setProvs(beneficiaries) {

        let provs = [];
        _.forEach(beneficiaries, o => {
            provs.push({
                InsType: '147',
                InsurantId: o.id.toUpperCase(),
                InsurantName: o.name,
                InsurantBirthday: o.birthday,
                BeneficiaryRelation: o.beneficiaryRelation,
                BeneficiaryName: o.beneficiaryRelation == 6 ? '法定繼承人' : o.beneficiaryName,
                Tbenef: o.beneficiaryRelation == 6 ? null : o.tbenef,
                AbenefZip: o.beneficiaryRelation == 6 ? null : o.abenefZip,
                Abenef: o.beneficiaryRelation == 6 ? null : o.abenef,
            });
        });

        if (store.state.ins147.selected) {
            store.commit('policy/setProvs', provs);
        }
    },
};

export default insurance;